import {
  BiFunnelShow,
  kBiVizStyleDefaults,
  kBiVizStyleOptionNames,
} from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleGroup } from '../StyleGroup';
import { StyleRow } from '../StyleRow';
import { biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

const kShows: Array<{ value: BiFunnelShow; label: string }> = [
  { value: BiFunnelShow.Both, label: '数值和转化率' },
  { value: BiFunnelShow.Values, label: '只显示数值' },
  { value: BiFunnelShow.Rates, label: '只显示转化率' },
];

/** What each stage's labels show: its value, its rates, or both. */
export const FunnelOptions = memo(({ style, onChange }: BiStyleOptionProps) => {
  const funnel = style?.funnel ?? kBiVizStyleDefaults.funnel;
  return (
    <StyleGroup
      title={kBiVizStyleOptionNames.funnel}
      onReset={
        style?.funnel
          ? () => onChange(biWithStyleOption(style, 'funnel', undefined))
          : null
      }
    >
      <StyleRow label="标签">
        {kShows.map(show => (
          <BiChip
            key={show.value}
            label={show.label}
            selected={funnel.show === show.value}
            onPress={() =>
              onChange(biWithStyleOption(style, 'funnel', { show: show.value }))
            }
          />
        ))}
      </StyleRow>
    </StyleGroup>
  );
});
